import { render } from "./BasketView.vue?vue&type=template&id=47772054"
import script from "./BasketView.vue?vue&type=script&lang=js"
export * from "./BasketView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__